import { FormFieldsConfig, commonFormFields } from '../types/formFields';
import { RetailerSelect } from '../../RetailerSelect/RetailerSelect';

const TRANSLATION_NS = 'events';

export const defaultFormConfig = {
  fields: [
    commonFormFields.firstName,
    commonFormFields.lastName,
    commonFormFields.email,
    commonFormFields.phone
  ],
  layout: {
    rows: [
      ['firstName', 'lastName'],
      ['email', 'phone']
    ]
  }
};

export const eventFormConfig: FormFieldsConfig = {
  'event-public-intro-class': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      {
        id: 'streetAddress',
        type: 'text',
        label: 'Project Street Address',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.streetAddress`,
        useGoogleAutocomplete: true
      },
      {
        id: 'city',
        type: 'text',
        label: 'City',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.city`,
        useGoogleAutocomplete: true
      },
      {
        id: 'province',
        type: 'select',
        label: 'Province',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.province`,
        options: [
          { label: 'form.selectProvince', value: '' },
          { label: 'Quebec', value: 'Quebec' },
          { label: 'Ontario', value: 'Ontario' }
        ]
      },
      {
        id: 'postalCode',
        type: 'text',
        label: 'Postal Code',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.postalCode`,
        useGoogleAutocomplete: true
      },
      {
        id: 'foodAllergies',
        type: 'text',
        label: 'Food Allergies / Dietary Restrictions',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.foodAllergies`
      },
      {
        id: 'guestName',
        type: 'text',
        label: 'Guest Name',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.guestName`
      },
      {
        id: 'productsInterested',
        type: 'text',
        label: 'Please list the products that you are interested in',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.productsInterested`
      },
      {
        id: 'tradeProfessionals',
        type: 'text',
        label: 'Please list the names of any trade professionals you are working with (Designer, Architect, Builder)',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.tradeProfessionals`
      },
      {
        id: 'retailer',
        type: 'select',
        label: 'Are you already working with an appliance retailer? If so, which one?',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.retailer`,
        component: RetailerSelect
      },
      {
        id: 'additionalComments',
        type: 'textarea',
        label: 'Additional Comments',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.additionalComments`
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['streetAddress', 'postalCode'],
        ['city', 'province'],
        ['foodAllergies', 'guestName'],
        ['productsInterested', 'tradeProfessionals'],
        ['retailer', 'additionalComments']
      ]
    }
  },
  'event-public-ownership-experience': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      {
        id: 'streetAddress',
        type: 'text',
        label: 'Project Street Address',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.streetAddress`,
        useGoogleAutocomplete: true
      },
      {
        id: 'city',
        type: 'text',
        label: 'City',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.city`,
        useGoogleAutocomplete: true
      },
      {
        id: 'province',
        type: 'select',
        label: 'Province',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.province`,
        options: [
          { label: 'form.selectProvince', value: '' },
          { label: 'Quebec', value: 'Quebec' },
          { label: 'Ontario', value: 'Ontario' }
        ]
      },
      {
        id: 'postalCode',
        type: 'text',
        label: 'Postal Code',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.postalCode`,
        useGoogleAutocomplete: true
      },
      {
        id: 'foodAllergies',
        type: 'text',
        label: 'Food Allergies / Dietary Restrictions',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.foodAllergies`
      },
      {
        id: 'guestName',
        type: 'text',
        label: 'Guest Name',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.guestName`
      },
      {
        id: 'productsOwned',
        type: 'text',
        label: 'Please list the products you own relevant to this class',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.productsOwned`
      },
      {
        id: 'additionalComments',
        type: 'textarea',
        label: 'Additional Comments',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.additionalComments`
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['streetAddress', 'postalCode'],
        ['city', 'province'],
        ['foodAllergies', 'guestName'],
        ['productsOwned', 'additionalComments']
      ]
    }
  },
  'event-dealer-training': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      {
        id: 'companyName',
        type: 'text',
        label: 'Company Name',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.companyName`
      },
      {
        id: 'location',
        type: 'select',
        label: 'Location',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.location`,
        options: [
          { label: 'form.selectProvince', value: '' },
          { label: 'Quebec', value: 'Quebec' },
          { label: 'Ontario', value: 'Ontario' }
        ]
      },
      {
        id: 'currentBrands',
        type: 'text',
        label: 'Which brands do you currently sell?',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.currentBrands`
      },
      {
        id: 'trainingGoals',
        type: 'text',
        label: 'What do you hope to gain from this training session?',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.trainingGoals`
      },
      {
        id: 'previousTraining',
        type: 'radio',
        label: 'Have you attended a Sub-Zero, Wolf, and Cove training before?',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.previousTraining`,
        options: [
          { label: 'form.yes', value: 'yes' },
          { label: 'form.no', value: 'no' }
        ]
      },
      {
        id: 'foodAllergies',
        type: 'text',
        label: 'Food Allergies / Dietary Restrictions',
        required: false,
        translationKey: `${TRANSLATION_NS}:form.foodAllergies`
      },
      {
        id: 'privateSession',
        type: 'radio',
        label: 'Are you interested in scheduling an in-store or private session with our team?',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.privateSession`,
        options: [
          { label: 'form.yes', value: 'yes' },
          { label: 'form.no', value: 'no' }
        ]
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['companyName', 'location'],
        ['currentBrands', 'trainingGoals'],
        ['previousTraining', 'foodAllergies'],
        ['privateSession']
      ]
    }
  },
  'event-ceu': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone,
      commonFormFields.company,
      commonFormFields.jobTitle,
      {
        id: 'creditReporting',
        type: 'select',
        label: 'Credit Reporting',
        required: true,
        translationKey: `${TRANSLATION_NS}:form.creditReporting`,
        options: [
          { label: 'form.selectCreditReporting', value: '' },
          { label: 'form.no', value: 'No' },
          { label: 'form.idcec', value: 'IDCEC' },
          { label: 'form.aia', value: 'AIA' }
        ]
      }
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone'],
        ['company', 'jobTitle'],
        ['creditReporting']
      ]
    }
  },
  'special-event': {
    fields: [
      commonFormFields.firstName,
      commonFormFields.lastName,
      commonFormFields.email,
      commonFormFields.phone
    ],
    layout: {
      rows: [
        ['firstName', 'lastName'],
        ['email', 'phone']
      ]
    }
  }
};
